import { useContext, useEffect, useState} from 'react';

import { Col, Row, Table, Tag, Tooltip } from 'antd';

import DiHorizontalScroll from '../DiHorizontalScroll';
import { TAG_BORDER } from '../../helpers/Globals';
import { DeleteOutlined } from '@ant-design/icons';
import formatEuro from '../../helpers/FormatEuro';
import { Context } from '../../helpers/Context';

const TableReceipts = ({data, hidePayment, hideTotals, isOpenedTable, cancelled, numberOfRows}) => {
  
  const [suspendedCount, setSuspendedCount] = useState(null); 
  const [suspended, setSuspended] = useState(null); 
  const [subtotal, setSubtotal] = useState(null); 

  const [filteredData, setFilteredData] = useState(data ?? []);
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [docTypes, setDocTypes] = useState([]);

  const { currency, baccoPaymentsList } = useContext(Context);
  
  var parentData = JSON.parse(JSON.stringify(data))

  const [customerNamesFilter, setCustomerNamesFilter] = useState([]);
  const [customerFilter, setCustomerFilter] = useState([]);
  const [docTypeFilter, setDocTypeFilter] = useState([]);
  const [waiterFilter, setWaiterFilter] = useState([]);
  const [tableFilter, setTableFilter] = useState([]);
  const [roomFilter, setRoomFilter] = useState([]);

  useEffect(() => {
    if (!data || data.length === 0) return;

    const roomSet = new Set();
    const waiterSet = new Set();
    const tableSet = new Set();
    const docTypeSet = new Set();
    const customerSet = new Set();
    const customerNamesSet = new Set();

    data.forEach((item) => {
      if (item.room) roomSet.add(item.room);
      if (item.waiter_name) waiterSet.add(item.waiter_name);
      if (item.table) tableSet.add(item.table);
      if (item.doc_type) docTypeSet.add(item.doc_type);
      if (item.name_customer) customerNamesSet.add(item.name_customer);
      if (item.customer?.CognomeNomeDitta) customerSet.add(item.customer.CognomeNomeDitta);
    });

    setRoomFilter([...roomSet].map(value => ({ text: value, value })));
    setWaiterFilter([...waiterSet].map(value => ({ text: value, value })));
    setTableFilter([...tableSet].map(value => ({ text: value, value })));
    setDocTypeFilter([...docTypeSet].map(value => ({ text: value, value })));
    setCustomerFilter([...customerSet].map(value => ({ text: value, value })));
    setCustomerNamesFilter([...customerNamesSet].map(value => ({ text: value, value })));
    
  }, [data]); 

  const columns = [
    {
      title: 'Data',
      dataIndex: 'date_bill',
      sorter: (a, b) => new Date(a?.date_bill).getTime() - new Date(b?.date_bill).getTime(),
      render: (value)=>value?.replace("T", " "),
      responsive: ['xl'],
    },
    {
      title: 'Cameriere',
      dataIndex: 'waiter_name',
      defaultSortOrder: 'descend',
      filters: waiterFilter,
      render:(value) => (value === "" || !value) ? "Operatore Cassa" : value,
      onFilter: (value, record) => record?.waiter_name?.indexOf(value) === 0,
      sorter: (a, b) => a.waiter_name.length - b.waiter_name.length,
      responsive: ['xl'],
    },
    {
      title: 'Sala',
      dataIndex: 'room',
      defaultSortOrder: 'descend',
      filters: roomFilter,
      onFilter: (value, record) => record?.room?.indexOf(value) === 0,
      sorter: (a, b) => a.room - b.room,
      responsive: ["xs","sm","md"],
    },
    {
      title: 'Tavolo',
      dataIndex: 'table',
      filters: tableFilter,
      onFilter: (value, record) => record?.table?.indexOf(value) === 0,
      sorter: (a, b) => a?.table - b?.table,
      responsive: ["xs","sm","md"],
    },
    {
      title: 'Azienda',
      dataIndex: 'customer',
      filters: customerFilter,
      onFilter: (value, record) => {
        if (!record.customer?.CognomeNomeDitta) return false;
        return record.customer.CognomeNomeDitta.toLowerCase().includes(value.toLowerCase());
      },
      render: (values) => <span className="fs-12">{values?.CognomeNomeDitta}</span>,
      responsive: ["xs","sm","md"],
    },
    {
      title: 'Nome',
      dataIndex: 'name_customer',
      filters: customerNamesFilter,
      onFilter: (value, record) => {
        if (!record.name_customer) return false;
        return record.name_customer.toLowerCase().includes(value.toLowerCase());
      },
      render: (values) => <span className="fs-12">{values}</span>,
      responsive: ["xs","sm","md"],
    },
    {
      title: 'Tipo',
      dataIndex: 'doc_type',
      filters: docTypeFilter,
      onFilter: (value, record) => record?.doc_type?.indexOf(value) === 0,
      render: (value)=><Tag className='fs-15' bordered={TAG_BORDER}>{value}</Tag>,
      responsive: ["xs","sm","md"],
    },
    {
      title: 'Sconto',
      dataIndex: 'discount',
      sorter: (a, b) => a.discount - b.discount,
      render: (value)=><Tag className='fs-15' bordered={TAG_BORDER} color='orange'>{formatEuro(value) + " " + currency}</Tag>,
      responsive: ["xs","sm","md"],
    },
    {
      title: 'Totale',
      dataIndex: 'total_sale',
      onFilter: (value, record) => record?.table?.indexOf(value) === 0,
      sorter: (a, b) => parseFloat(a.total_sale) - parseFloat(b.total_sale),
      render: (value)=><Tag className='fs-15' bordered={TAG_BORDER} color='green'>{formatEuro(value) + " " + currency}</Tag>,
      responsive: isOpenedTable ? [] : ["xs","sm","md"],

    },
    {
      title: 'Totale',
      dataIndex: 'total',
      onFilter: (value, record) => record?.table?.indexOf(value) === 0,
      sorter: (a, b) => parseFloat(a.total_sale) - parseFloat(b.total_sale),
      render: (value)=><Tag className='fs-15' bordered={TAG_BORDER} color='green'>{formatEuro(value) + " " + currency}</Tag>,
      responsive: !isOpenedTable ? [] : ["xs","sm","md"],
    },
    { 
      title: 'Pagamenti',
      dataIndex: 'payments',
      responsive: hidePayment ? [] : ["xs","sm","md"],
      render: (value) =>
        value?.map((payment) => {
          const paymentMethod = baccoPaymentsList.find(paymentMethod => paymentMethod?.code === payment?.code);
          
          // Verifica che paymentMethod esista
          if (payment && paymentMethod) {
            return (
              <Tag key={payment.code} className='fs-12 capitalize'  bordered={TAG_BORDER}>
                {paymentMethod.name} {formatEuro(payment.amount)} {currency}
              </Tag>
            );
          }
        })
      },
  ];
  

  // ------------- calcolo dei dati aggregati ---------------—

    useEffect(() => {
      const data = filteredData?.length > 0 ? filteredData : data ?? [];

      if (!data || data.length === 0) return;

      const docTypeCounts = {};
      
      var tempSuspendedCount = 0;
      var tempSuspended = 0;
      var tempSubtotal= 0;
      let discount = 0;
      

      data.forEach(item => {
        discount += parseFloat(item.discount) || 0; // Sommo lo sconto totale, gestendo valori non numerici
        if (!docTypeCounts[item.doc_type]) {
          docTypeCounts[item.doc_type] = { doc_type: item.doc_type, count: 0, total: 0 };
        }

        /////////////////////////////////////////////////////////////////////////////////////////// 
          //////////////////// se lo scontrino non ha dei pagamenti è un sospeso ///////////////
        /////////////////////////////////////////////////////////////////////////////////////////// 
        if (item["payments"]?.length === 0) {
          tempSuspended += parseFloat(item["total_sale"]);
          tempSuspendedCount ++;
        }
        /////////////////////////////////////////////////////////////////////////////////////////// 
          //////////////////// se lo scontrino non ha dei pagamenti è un sospeso ///////////////
        ///////////////////////////////////////////////////////////////////////////////////////////

        // Aggiorno i valori esistenti
        tempSubtotal += parseFloat(item.total_sale);
        docTypeCounts[item.doc_type].count++;
        docTypeCounts[item.doc_type].total += parseFloat(item.total_sale) || 0;
      });

      setDocTypes(Object.values(docTypeCounts)); // Converto l'oggetto in un array di oggetti
      setSuspendedCount(tempSuspendedCount);
      setSuspended(tempSuspended);
      setTotalDiscount(discount);
      setSubtotal(tempSubtotal);

    }, [data, filteredData]);

  
  // ------------- calcolo dei dati aggregati ---------------—
  
  return (
    <>
        {!hideTotals &&
          <Row justify={"center"} id="correctionListTable">
                <div className='mb-30 py-10 flex flex-wrap gap-35 w-100 justify-center'>
                    
                    <div className='flex-grow mw-100'>
                        <Tag bordered={TAG_BORDER}  color='green' className='di-corrections-ribbon'>
                            Totale
                        </Tag>
                        <Tag bordered={TAG_BORDER}  color='green' className='flex wrap gap-10 p-10 justify-center align-center m-0 h-100'>
                          <Tag bordered={TAG_BORDER} color='green' className='fs-20'>{`${formatEuro(subtotal)} ${currency}`}</Tag>
                        </Tag>
                    </div>
                    
                    <div className='flex-grow mw-100'>
                        <Tag bordered={TAG_BORDER}  color='orange' className='di-corrections-ribbon'>
                            Sconto Totale
                        </Tag>
                        <Tag bordered={TAG_BORDER}  color='orange' className='flex wrap gap-10 p-10 justify-center align-center m-0 h-100'>
                          <Tag bordered={TAG_BORDER} color='orange' className='fs-20'>{`${formatEuro(totalDiscount)} ${currency}`}</Tag>
                        </Tag>
                    </div>
                    
                    <div className='flex-grow mw-100'>
                        <Tag bordered={TAG_BORDER}  color='cyan' className='di-corrections-ribbon'>
                            Sospesi
                        </Tag>
                        <Tooltip title={`Numero documenti sospesi: ${suspendedCount}`} className='fs-15 cursor-pointer'>
                          <Tag bordered={TAG_BORDER}  color='cyan' className='flex wrap gap-10 p-10 justify-center align-center m-0 h-100'>
                            <Tag bordered={TAG_BORDER} color='cyan' className='fs-20'>{`${suspended ? formatEuro(suspended) : 0} ${currency}`}</Tag>
                          </Tag>
                       </Tooltip>
                    </div>
                    
                    <div className='flex-grow mw-100'>
                        <Tag bordered={TAG_BORDER} className='di-corrections-ribbon'>
                            Tipi di documento <span className='opacity-08'>(al netto dell'annullo)</span>
                        </Tag>
                        <Tag bordered={TAG_BORDER} className='flex wrap gap-10 p-10 justify-center align-center m-0 h-100'>
                         <DiHorizontalScroll>
                            {docTypes?.length > 0 &&
                              docTypes.map((e, index) => {
                                return (
                                      <Tooltip title={`Emessi: ${e.count}`} key={`docType-${index}`} className='fs-15 cursor-pointer'>
                                          <Tag bordered={TAG_BORDER} className='text-center'>
                                            {e.doc_type} <br />
                                            {formatEuro(e.total)+currency}
                                          </Tag>
                                      </Tooltip>
                                    )
                                })
                              }
                              {cancelled &&
                                <Tooltip clas title={`Doucumenti annullati: ${cancelled.number_of_cancelled}`} className='fs-15 cursor-pointer'>
                                  <Tag color='red' bordered={TAG_BORDER} className='text-center'>
                                      <DeleteOutlined /> 
                                      <br/>
                                      {formatEuro(cancelled.amount_cancelled)+currency}
                                  </Tag>
                                </Tooltip>
                              }
                         </DiHorizontalScroll>
                        </Tag>
                    </div>
    
                </div>
          </Row>
        }
      
        <Table
          locale={{ 
              triggerDesc: 'Ordine decrescente',
              triggerAsc: 'Ordine crescente', 
              cancelSort: "Clicca per cancellare l'ordinamento"
          }}
          columns={columns}
          pagination={{
             pageSize:numberOfRows ?? 5
          }}
          className="mobile-x-scroll"
          expandable={{
            expandedRowRender: (record) => {
              var children = data[data?.findIndex(item => item.key === record.key)]?.children;
              const columns = [
                {
                  title: 'Descrizione',
                  dataIndex: 'description',
                  key: 'description',
                },
                {
                  title: 'Quantità',
                  dataIndex: 'quantity',
                  key: 'quantity',
                  render: (value)=>value + " pz.",
                },
                {
                  title: 'Totale',
                  dataIndex: 'amount',
                  key: 'amount',
                  render: (value)=>formatEuro(value) + " " + currency,
                },
                {
                  title: 'Prezzo',
                  dataIndex: 'price',
                  render: (value)=>formatEuro(value) + " " + currency,
                  key: 'price',
                }
              ];
              return(
                <Table
                  className='di-table-nested'
                  columns={columns}
                  dataSource={children}
                  pagination={false}
                  bordered
                /> 
              )
          }
          }}
          onChange={
              (pagination, filters, sorter, extra) => {
                  setFilteredData(extra.currentDataSource)
              } 
          } 
          dataSource={parentData}
          scroll={{ x: 'max-content' }} 
          bordered
        />
    </>
  );
};
export default TableReceipts;